import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const StickyArticleCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm border-t border-gray-200 py-2.5 px-4 md:hidden" data-testid="sticky-article-cta">
    <Link to="/start-here" className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-sm font-semibold text-white" style={{ backgroundColor: "#C8614A" }}>
      Start Here <ArrowRight className="w-4 h-4" />
    </Link>
  </div>
);

export default StickyArticleCTA;
